import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
export default {
	all:{
		jiantizhongwen:'Simplified Chinese',
		fantizhongwen: 'Traditional Chinese',
		yingwen: 'English',
		yuyanxuanze: 'Language selection',
		shezhi: 'setting',
		xiugaimima: 'Change password',
		yinsizhengce: 'Privacy Policy',
		guanyuwomen: 'About Us',
		mimashuoming: 'The password must consist of a combination of 8-20 letters and numbers, and cannot be purely numeric or purely alphabetic',
		qingshurujiumima: 'Please enter your old password',
		qingshuruxinmima: 'Please enter a new password',
		quedingxiugai: 'Confirm modification',
		
		shouye: 'Home Page',
		zhibo: 'live broadcast',
		wode: 'my',
		xitongxiaoxi: 'System',
		wodedingdan: 'Order',
		bangzhufankui: 'Feedback',
		xiugaiziliao: 'Modify profile',
		xiaofeimingxi: 'Consumption Details',
		zhibojilu: 'Live broadcast record',
		tijiao: 'Submit',
		caozuochenggong: 'Operation successful',
		tishi: 'prompt',
		quedingtuichudengluma:'Are you sure you want to log out?',
		queding: 'confirm',
		wentibangzhu: 'Question Help',
		woyaofankui: 'I want to give feedback',
		fankuiwenti: 'feedback issue',
		qingmiaoshuniyaofankuidewenti:'Please describe the problem you want to feedback...',
		sousuo: 'search',
		sousuoniganxingqudeneirong: 'Search for content that interests you',
		zhibojianbiaoti: 'live stream title',
		zhibojianbeijing: 'Live streaming room background',
		zhibojianbiaoqian: 'live streaming room tag',
		zhibojianhuazhi: 'live streaming video quality',
		geinidezhibojianqugemingziba: 'Give your live streaming room a name~',
		qingshurukaibomiyao: 'Please enter the broadcast secret key',
		kaishizhibo: 'Start live streaming',
		shengyin: 'sound',
		liwutexiao: 'gift special effect',
		gengduo: 'more',
		gouwuche: 'shopping cart',
		zaixianguanzhong:'online audience',
		danmushuoming:'The platform strictly prohibits minors from recharging and tipping, as well as inducing tipping through private transactions such as playing together. It also strictly prohibits content related to pornography, politics, abuse, etc. Please pay attention to property safety, beware of online fraud, and consume rationally',
		tianjiaguanliyuan: 'Add administrator',
		jinyan: 'mute',
		jiechuejinyan: 'lift the mute',
		tichufangjian: 'kick out of the room',
		shangpinxiangqing: 'Product Details',
		lijijiagou:'Add to Cart Now',
		xuanzeguige: 'Select specification',
		quanbuliwu: 'All gifts',
		ge: 'a',
		bi: 'coin',
		guanliyuan: 'administrator',
		kuaijieduanyu: 'Quick Phrases',
		gonggao: 'Announcement',
		xinzengkuaijieduanyu: 'New quick phrases',
		qingshuru: 'Please input',
		wangjimima: 'Forgot password',
		youxiangzhuce: 'Email registration',
		huoquyanzhengma: 'Obtain verification code',
		qingshuruningdeyouxiangzhanghao:'Enter your email account',
		qingshuruyanzhengma: 'Please enter the verification code',
		qingshurumima: 'Please enter your password',
		mimadenglu: 'Password login',
		woyiyuedubingtongyi:'I have read and agree',
		yonghuxieyi: 'User Agreement',
		yinsixieyi: 'Privacy Agreement',
		denglu: 'login',
		chongxindenglu: 'Log in again',
		xiayibu: 'Next step',
		haimeizhanghao: 'I do not have an account yet',
		quzhuce:"go register",
		yiyouzhanghao: 'Already have an account',
		qudenglu: 'Go to login',
		shezhijibenxinxi: 'Set basic information',
		nichengtishi: 'Only letters, numbers, and punctuation marks are supported. It must be at least 6 characters long and cannot contain spaces.',
		shezhiyonghuming: 'Set username',
		yonghumingtishi: 'The username should be 6-18 characters long, consisting of uppercase and lowercase letters or numbers',
		shezhijiaoyimima: 'Set transaction password',
		jiaoyimimatishi: 'The transaction password must consist of a combination of 6 digits',
		qingxuanze: 'Please choose',
		yaoqingma:'Invitation code (optional)',
		qingshuruyaoqingma: 'Enter invitation code',
		shezhixinmima: 'Set new password',
		xuanzeningdeguojia: 'Select your country',
		zhuce: 'register',
		qingshuruyonghuming: 'Please enter your username',
		gaoqinghuazhi: 'high-definition picture quality',
		putonghuazhi: 'Normal picture quality',
		kaishizhibo: 'Start live streaming',
		zengsong:'Give',
		jinrulezhibojian: 'Enter the live streaming room',
		shuodianshenmene:'What do you want to say ...',
		zanwushuju: 'No data available',
		songgei:'give to',
		huifang:'playback',
		xunibi:'virtual currency',
		quanbu:'all',
		appxiazai:'Download',
		dingdanjine: 'Order amount',
		dingdanbianhao: 'Order number',
		chuangjianshijian: 'creation time',
		zhubozanshilikai: 'The host is temporarily away',
		mashanghuilai: 'I will be back soon'
	},
}
 


// WEBPACK FOOTER //
// ./src/i18n/langs/en.js